/*
  Handles events raised by the notifications module which the editor and its plugins
  use to let the user know about stuff. Here we show those notifications as toasts.

  Plugins can invoke a notification by calling
  editor.ui.notifications.showSuccess(...)

  https://ckeditor.com/docs/ckeditor5/latest/api/module_ui_notification_notification-Notification.html
*/

import { Plugin, Notification } from "ckeditor5";
import React from "react";

import { toast } from "@examspark/common-ui";

import { NotificationShowEvent } from "../_nonpublic/notification";

export default class ToastNotifications extends Plugin {
  public static get requires() {
    return [Notification];
  }

  public init() {
    this.editor.plugins
      .get(Notification)
      .on<NotificationShowEvent>("show", (e, data) => {
        toast[data.type](
          <div>
            {!!data.title && <h3>{data.title}</h3>}
            <p>{data.message}</p>
          </div>,
        );

        e.stop();
      });
  }
}
